import { useEffect, useState } from 'react'
import { callAPIForAutoLogin, callAPIForLogin, PROD_URL } from '../../utilities/service'
import './index.scss'
import { Loader } from '../common/Loader'
import { useCustomContext } from '../../state/CustomContext'
import { useNavigate, useSearchParams } from 'react-router-dom'
export const Login = () => {
    const context = useCustomContext();
    const { dispatch } = context;
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [roles, setRoles] = useState([])
    const [selectedRole, setSelectedRole] = useState<any>({})
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams(); // Get query params
    const autologin_username = searchParams.get("username"); // Extract specific param
    const autologin_roleid = searchParams.get("roleid"); // Extract specific param
    const autologin_token = searchParams.get("token"); // Extract specific param

    const validateLogin = async () => {
        if (roles?.length > 0) {
            if (selectedRole?.id) {
                dispatch({
                    type: 'UPDATE_LOGIN',
                    role_id: selectedRole.id,
                    role_name: selectedRole.name,
                });
                navigate('/patient-view')
            } else {
                alert("Please select the role")
            }

        } else {
            setLoading(true)
            const response = await callAPIForLogin({ username, password });
            setLoading(false)
            const data = response?.[0]?.[0];

            if (data?.id) {
                const roles: any = response[1]
                setRoles(roles)

                if (roles.length === 1) {
                    dispatch({
                        type: 'UPDATE_LOGIN',
                        user_id: data.id,
                        token: data.token,
                        display_name: data.display_name,
                        role_id: response[1].id,
                        role_name: response[1].name
                    });
                    navigate('/patient-view')
                } else if (roles.length > 1) {
                    dispatch({
                        type: 'UPDATE_LOGIN',
                        user_id: data.id,
                        token: data.token,
                        display_name: data.display_name
                    });
                } else if (roles.length === 0) {
                    alert("No roles mapped for this user. Please contact your administrator")
                }

            } else {
                alert("Invalid Credentials")
            }
        }

    }
    const onRoleSelect = (event: any) => {
        setSelectedRole({})
        if (event.target.value === "-1") {
            alert("Please select the role")
        } else {
            setSelectedRole(roles[event.target.selectedIndex - 1])
        }
    }
    const autoLogin = async () => {
        const result = await callAPIForAutoLogin({ username: autologin_username, roleid: autologin_roleid, token: autologin_token })
        if (result?.length === 3) {
            const data = result[0]?.[0];
            const role = result[1]?.[0];
            const autoLoginInfo = result[2]?.[0];
            if (data && role && autoLoginInfo) {
                dispatch({
                    type: 'UPDATE_LOGIN',
                    user_id: data.id,
                    token: data.token,
                    display_name: data.display_name,
                    role_id: role.id,
                    role_name: role.name
                });
                //console.log(`/${autoLoginInfo.redirect_url.replace(PROD_URL, '')}`)
            
                navigate(`/${autoLoginInfo.redirect_url.replace(PROD_URL, '')}`)

            }

        }

    }
    useEffect(() => {
        if (autologin_token && autologin_username && autologin_roleid) {
            autoLogin();
        }
    }, [])// eslint-disable-line react-hooks/exhaustive-deps
    return <div className="login">
        {loading && <Loader />}


        <div className='panel'>
            <div className='row'>
                <div className='col-lg-6'>
                    <img alt="E Ambulance" width="100%" height={"100%"} src='https://wallpapercave.com/wp/wgdPkOl.jpg' />
                </div>
                <div className='col-lg-6'>
                    <div>
                        <div className='form-option'>
                            <div className='field-title'>Enter the username:</div>
                            <input type="text" className='form-control' placeholder="Enter the username" onChange={(event: any) => {
                                setUsername(event.target.value)
                            }} />
                        </div>
                        <div className='form-option'>
                            <div className='field-title'>Enter the password:</div>

                            <input type="password" className='form-control' placeholder="Enter the password" onChange={(event: any) => {
                                setPassword(event.target.value)
                            }} />
                        </div>
                        {roles?.length > 0 && (
                            <div className='form-option'>
                                <div className='field-title'>Select the role:</div>
                                <select value={selectedRole?.id || "-1"}
                                    onChange={onRoleSelect} className='form-control'>
                                    <option value="-1">--Select Role--</option>
                                    {
                                        roles.map((role: any) => {
                                            return <option key={role.id} value={role.id}>{role.name}</option>
                                        })
                                    }
                                </select>
                            </div>
                        )}
                        <div className='action-set'>
                            <input type="button" value="Login" onClick={validateLogin} />
                            <input type="button" value="Reset" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div >
}